// takes a string in this format: "{20,0,10,25}" and turns it in an array of numbers
// so we can use array destructuring to get stuff like padding or dimensions values
const parseValue = value =>
  value
    .replace("{" || "}", "")
    .split(",")
    .map(i => parseFloat(i));

export default parseValue;
